import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    selectWrapper: css({
        width: '100%',
        marginTop: '-2px',
    }),

    label: css({
        display: 'flex',
        marginTop: '-3px',
    }),

    labelDisabled: css({
        color: `${theme.palette.text.disabled} !important`,
    }),

    asterisk: css({
        color: theme.palette.primary.main,
        marginLeft: '3px',
    }),

    formConfirmationText: css({
        marginRight: '12px',
        marginLeft: '11px',
    }),

    confirmationError: css({
        marginLeft: '0px',
    }),

    selectText: css({
        '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            paddingRight: '32px',
        },
    }),

    dropdownWrap: css({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
    }),
};
